import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const VALUE_PROPS = [
  "E-Mails & Dokumente in Sekunden korrigieren",
  "Einheitlicher Schreibstil im ganzen Team",
  "DSGVO-konform – keine Datenweitergabe",
];

const ROTATING_PHRASES = [
  "ohne Stress.",
  "für E-Mails.",
  "für Bewerbungen.",
  "für Behördenschreiben.",
  "für Ihr Team.",
];


export function HeroSection() {
  const [phraseIndex, setPhraseIndex] = useState(0);

  // Rotate phrases
  useEffect(() => {
    const interval = setInterval(() => {
      setPhraseIndex((i) => (i + 1) % ROTATING_PHRASES.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative pt-20 pb-16 md:pt-32 md:pb-24" aria-labelledby="hero-heading">
      <div className="container relative px-4">
        <div className="mx-auto max-w-3xl text-center">
          {/* Trust badge */}
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-border/50 bg-muted/50 px-4 py-1.5 text-xs text-muted-foreground">
            <span className="h-1.5 w-1.5 rounded-full bg-primary" />
            Optimiert für den DACH-Geschäftsalltag
          </div>

          <h1
            id="hero-heading"
            className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl leading-[1.1]"
          >
            Professionelles Deutsch –{" "}
            <span className="block sm:inline h-[1.2em] relative">
              <AnimatePresence mode="wait">
                <motion.span
                  key={phraseIndex}
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -15 }}
                  transition={{ duration: 0.4 }}
                  className="text-primary inline-block"
                >
                  {ROTATING_PHRASES[phraseIndex]}
                </motion.span>
              </AnimatePresence>
            </span>
          </h1>

          <p className="mt-6 text-lg text-muted-foreground md:text-xl max-w-2xl mx-auto leading-relaxed">
            Der einzige Textassistent mit automatischer AGG- und DSGVO-Prüfung — speziell für den DACH-Markt.
          </p>

          {/* Value props */}
          <ul className="mt-8 flex flex-col items-center gap-2 sm:flex-row sm:justify-center sm:gap-6 text-sm text-muted-foreground">
            {VALUE_PROPS.map((prop) => (
              <li key={prop} className="flex items-center gap-2">
                <CheckCircle2 className="h-4 w-4 text-primary shrink-0" />
                {prop}
              </li>
            ))}
          </ul>

          {/* CTA */}
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to="/register">
              <Button size="lg" className="w-full sm:w-auto text-sm sm:text-base px-6 sm:px-8 py-3 sm:py-4 group max-w-[calc(100vw-32px)] sm:max-w-none">
                <span className="block sm:hidden text-center">
                  Kostenlos starten<br />
                  <span className="text-xs opacity-90">7 Tage testen →</span>
                </span>
                <span className="hidden sm:block">
                  Kostenlos starten — 7 Tage alle 8 Werkzeuge testen
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </span>
              </Button>
            </Link>
            <span className="text-xs text-muted-foreground text-center">Keine Kreditkarte · 7 Tage Pro-Test</span>
          </div>

          {/* Trust signals */}
          <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-sm text-muted-foreground">
            <span>🇩🇪 🇦🇹 🇨🇭 DACH-Markt</span>
            <span className="hidden sm:inline text-border">·</span>
            <span>DSGVO-konform</span>
            <span className="hidden sm:inline text-border">·</span>
            <span>Keine Trainingsverwendung</span>
          </div>
        </div>

      </div>
    </section>
  );
}
